import { useState } from "react";

import { createTheme, StyledEngineProvider, ThemeProvider } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";

import classes from "./index.module.scss";
import { userApi } from "../../../api"; 

const innerTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

type Props = {
  open: boolean;
  onClose: (refreshData?: boolean) => void;
  user: any;
};

const UserRole = ({ open, onClose, user }: Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleRoleSelect = async (role: number) => {
    setIsLoading(true);
    await userApi.updateUserRole({ user_id: user.uid, role }).then((data) => {
      if (data.status < 400) {
        onClose(true);
      } else {
        alert("There was a problem when updating the user role");
      }
      setIsLoading(false);
    });
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={innerTheme}>
        <Dialog
          PaperProps={{ style: { backgroundColor: "#151515" } }}
          {...{ open }}
          onClose={() => onClose()}
        >
          <DialogTitle>Change user role</DialogTitle>
          <div className={classes.modalBody}>
            Selected user: <p className={classes.userEmail}>{user?.email}</p>
          </div>

          {/* ROLE BUTTONS */}
          <div className={classes.buttonContainer}>
            <Button
              style={{
                width: "100%",
                background:
                  user.role === "USER" ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0)",
                color:
                  user.role === "USER"
                    ? "rgba(255, 255, 255, 1)"
                    : "rgba(255, 255, 255, 0.7)",
              }}
              disabled={user.role === "USER"}
              variant="contained"
              onClick={() => handleRoleSelect(0)}
            >
              {isLoading && user.role !== "USER" ? (
                <CircularProgress size="20px" />
              ) : (
                "USER"
              )}
            </Button>

            <Button
              style={{
                width: "100%",
                background:
                  user.role === "ADMIN" ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0)",
                color:
                  user.role === "ADMIN"
                    ? "rgba(255, 255, 255, 1)"
                    : "rgba(255, 255, 255, 0.7)",
              }}
              disabled={user.role === "ADMIN"}
              variant="contained"
              onClick={() => handleRoleSelect(1)}
            >
              {isLoading && user.role !== "ADMIN" ? (
                <CircularProgress size="20px" />
              ) : (
                "ADMIN"
              )}
            </Button>
          </div>
        </Dialog>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default UserRole;
